import React, { useContext } from 'react';
import { LogicContextType } from './types';

export const LogicContext = React.createContext<LogicContextType | null>(null);

export function useLogicContext() {
  return useContext(LogicContext) as LogicContextType;
}
